export default __webpack_public_path__ + "static/media/placement_impact.152ec448.pdf";